// Created by PeakXin on 2025/12/25.
import { getAgentInfo } from '@/api/three-d-vision'

const state = {
  agentInfo: {}
}

const getters = {
  agentInfo: (state) => state.agentInfo
}

const mutations = {
  SET_AGENT_INFO: (state, agentInfo) => {
    state.agentInfo = agentInfo
  }
}

const actions = {
  // 获取代理商用户信息
  getAgent({ commit, dispatch }) {
    return new Promise(async (resolve, reject) => {
      try {
        // 通过 getInfo() 方法获取最新的 userInfo
        const userInfo = await dispatch('user/getInfo', null, { root: true })

        // 判断 userInfo 的 member 属性值是否有信息
        if (userInfo && userInfo.member) {
          // 有 member 属性值，调用 getAgentInfo 方法
          getAgentInfo()
            .then((response) => {
              const { data } = response
              if (!data) {
                reject('验证失败，请重新登录')
              }
              //console.log('SET_AGENT_INFO', data)
              commit('SET_AGENT_INFO', data)
              resolve(data)
            })
            .catch((error) => {
              reject(error)
            })
        } else {
          // 没有 member 属性值，清空 agentInfo 并完成流程，无需报错
          commit('SET_AGENT_INFO', {})
          console.log('userInfo 没有 member 属性值')
          resolve(null)
        }
      } catch (error) {
        reject(error)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
